import { formatTimeString } from '../../utils/formatters'
import BaseExporter from './base_exporter'

export default class AccessCodesExporter extends BaseExporter {
  export() {
    const data = this.data.map((entry) => {
      const dataRow = []
      if (!entry) {
        return new Array(this.header.length)
      }

      dataRow.push(entry.code)
      dataRow.push(entry.is_active)
      dataRow.push(entry.child_codes)
      dataRow.push(entry.parent_code)
      dataRow.push(formatTimeString(entry.created))
      dataRow.push(formatTimeString(entry.created))

      return dataRow
    })

    data.unshift(this.header)
    return data
  }
}
